// extracted by mini-css-extract-plugin
module.exports = {"content":"layout-b_content__3E3kJ","child":"layout-b_child__30UrN","layoutAContainer":"layout-b_layoutAContainer__DlBAi"};